/**
 * Fetch wrapper used by every generated endpoint (web and mobile).
 * The host app registers how to get a base URL and an access token; nothing here knows about
 * MSAL or Expo. The org is never sent by the client: the API resolves it from the signed-in user.
 */

type TokenProvider = () => Promise<string | null>;

let baseUrl = '';
let getToken: TokenProvider = async () => null;

export function configureApiClient(options: { baseUrl?: string; getToken: TokenProvider }): void {
  baseUrl = options.baseUrl ?? '';
  getToken = options.getToken;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
  ) {
    super(`API request failed with status ${status}`);
  }
}

export async function apiFetch<T>(url: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const token = await getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const response = await fetch(`${baseUrl}${url}`, { ...init, headers });
  const text = await response.text();
  const body: unknown = text ? JSON.parse(text) : undefined;
  if (!response.ok) throw new ApiError(response.status, body);
  // orval's fetch client expects { data, status, headers }.
  return { data: body, status: response.status, headers: response.headers } as T;
}
